import React from 'react';

export const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

export const emptyDate = () => ({ month: '', day: '', year: '' });

export function parseDate(value, { minYear = 1900, maxYear = new Date().getFullYear() } = {}) {
  const month = Number(value.month);
  const day = Number(value.day);
  const year = Number(value.year);
  const real = new Date(year, month - 1, day);
  if (!month || !day || !year || real.getFullYear() !== year || real.getMonth() !== month - 1 || real.getDate() !== day) {
    return { error: 'Enter a real date.' };
  }
  if (year < minYear || year > maxYear) {
    return { error: `Choose a year from ${minYear} through ${maxYear}.` };
  }
  return { year, month, day };
}

export function dateParam({ year, month, day }) {
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

export function chartDateHref(date) {
  if (!date || !date.year || !date.month || !date.day) return '/birth-chart/';
  return `/birth-chart/?date=${dateParam(date)}`;
}

export function dateFromSearch(search) {
  const match = /(?:^|[?&])date=(\d{4})-(\d{2})-(\d{2})/.exec(search || '');
  if (!match) return null;
  return { year: match[1], month: String(Number(match[2])), day: String(Number(match[3])) };
}

const DateFields = ({ value, onChange, legend = 'Date of birth' }) => (
  <fieldset className="astro-date-fieldset">
    <legend>{legend}</legend>
    <div className="astro-date">
      <select aria-label="Month" value={value.month} onChange={(event) => onChange({ ...value, month: event.target.value })}>
        <option value="">Month</option>
        {MONTHS.map((month, index) => <option key={month} value={index + 1}>{month}</option>)}
      </select>
      <input
        aria-label="Day"
        inputMode="numeric"
        placeholder="Day"
        value={value.day}
        onChange={(event) => onChange({ ...value, day: event.target.value.replace(/\D/g, '').slice(0, 2) })}
      />
      <input
        aria-label="Year"
        inputMode="numeric"
        placeholder="Year"
        value={value.year}
        onChange={(event) => onChange({ ...value, year: event.target.value.replace(/\D/g, '').slice(0, 4) })}
      />
    </div>
  </fieldset>
);

export default DateFields;
